import React from 'react'
import { FormContextProvider } from '../../../../context/formContext'
import DetailsForm from './DetailsForm'
import Toast from '../../../../components/Toast/Toast'
const DetailsFormWrapper = () => {
  return (
    <FormContextProvider>
      <Toast />
      <DetailsForm />
    </FormContextProvider>
  )
}

export default DetailsFormWrapper
